/*eslint-disable */

import 'highlight.js/lib/languages/css';
import 'highlight.js/lib/languages/javascript';
import'highlight.js/styles/a11y-dark.css';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/jquery.mCustomScrollbar.css';
import './assets/css/extra.css';
import './assets/fonts/alien/stylesheet.css';
import './assets/fonts/acssans/stylesheet.css';
import './assets/fonts/beon/stylesheet.css';
import './assets/fonts/myrid-pro/stylesheet.css';
import './assets/fonts/strasua-regular/styles.css';
import './assets/fonts/AlienAndroid/styles.css';
import './assets/fonts/retro/stylesheet.css';
import './assets/fonts/sylfaen/styles.css';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import 'slick-carousel/slick/slick.css';
import "vue-tel-input/dist/vue-tel-input.css";
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'vue-multiselect/dist/vue-multiselect.min.css';

import App from './App/index';
import Meta from 'vue-meta';
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import VeeValidate from 'vee-validate';
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueCarousel from 'vue-carousel';
import VueHighlightJS from 'vue-highlightjs'
import VueLocalStorage from 'vue-localstorage'
import VueRouter from 'vue-router';
import VueSlick from 'vue-slick';
import VueSlimScroll from 'vue-slimscroll'
import VueVirtualScroller from 'vue-virtual-scroller'
import axios from 'axios'
import customDirective from './_helpers/custom.directive';
import draggable from "vuedraggable";
import highlightjs from './services/highlightjs';
import interceptor from './services/interceptor';
import mCustomScrollbar from './assets/js/jquery.mCustomScrollbar.js';
import root from './_helpers/roots';
import router from './route';
import store from './store/store.js';
import timestamp from './services/timestamp';

Vue.config.productionTip = false;
Vue.use(VueVirtualScroller)
Vue.use(VueLocalStorage)
Vue.use(VueRouter, VueCarousel, VueSlick);
Vue.use(Meta);
Vue.use(VeeValidate, {
  validity: true,
  required: true
});
Vue.use(VueAxios, axios);
Vue.use(VueSlimScroll)

Vue.use(PerfectScrollbar)

// SynTaxHighlighter Register only languages that you want
Vue.use(VueHighlightJS)

// Bus
export const bus = new Vue();
var $ = window.jQuery = require('jquery');
const token = localStorage.getItem('token');
if (token != '' && token != null) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}

if (navigator.userAgent.indexOf('Mac') > 0) {
  $('body').addClass('mac');
}

// Check the user's auth status when the app starts
store.dispatch('checkAuth')

// Check the Paypal SdK Script
const scriptLoader = {
  loaded: [],
  load(src) {
    if (this.loaded.indexOf(src) !== -1) {
      return
    }
    this.loaded.push(src)
    if (document) {
      const script = document.createElement('script')
      script.setAttribute('src', src)
      document.head.appendChild(script)
    }
  }
}

Vue.use({
  install() {
    Vue.prototype.$scriptLoader = scriptLoader
  }
})


axios.interceptors.request.use(function(config) {
  //vuex mutation set loading state to true
  if ($('body').hasClass('public-routes')) {
    const URL = root.publicLeaderboardUrl.link;
    if(config.url != URL){
      $('.routeloader').css({
        'display': 'flex'
      });
    }
  }else {
    $('.httploader').css({
      'display': 'flex'
    });
  }
  return config;
}, function(error) {
  if ($('body').hasClass('public-routes')) {
    $('.routeloader').hide()
  } else {
    $('.httploader').hide()
  }
  return Promise.reject(error);
});

axios.interceptors.response.use(function(config) {
  //vuex mutation set loading state to false
  if ($('body').hasClass('public-routes')) {
    $('.routeloader').hide()
  } else {
    $('.httploader').hide()
  }
  return config;
}, function(error) {
  if ($('body').hasClass('public-routes')) {
    $('.routeloader').hide()
  } else {
    $('.httploader').hide()
  }
  return Promise.reject(error);
});

new Vue({
  render: h => h(App),
  router: router,
  store: store,
  interceptor,
  mCustomScrollbar,
  timestamp,
  highlightjs,
}).$mount('#app')
